export enum SnackBarAction {
    closeButtonClicked = 'closeButtonClicked',
}
